import { Routes } from '@angular/router';
import { userRoutes } from './features/user/user.routes';
import { adminRoutes } from './features/admin/admin.routes';
import { noAuthGuard } from './core/guards/no-auth.guard';
import { authGuard } from './core/guards/auth.guard';


export const routes: Routes = [
    { path: '', redirectTo: '/login', pathMatch: 'full', title: 'Transmaritime' },
    {
        title: 'Transmaritime - Login',
        path: 'login',
        loadComponent: () => import('./features/auth/pages/login/login').then(m => m.Login),
        canActivate: [noAuthGuard]
    },
    {
        path: '',
        loadComponent: () => import('./shared/features/dashboard/dashboard.component').then(m => m.DashboardComponent),
        canActivate: [authGuard],
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            ...userRoutes,
            ...adminRoutes,
        ]
    },
    {
        path: '**',
        redirectTo: '/login', 
        pathMatch: 'full'
    }

];
